import {Component, input, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {HttpErrorResponse} from "@angular/common/http";
import {AlertComponent} from "../../../../common/alert/alert.component";
import {AlertService} from "../../../../common/alert/alert.service";
import {PinholeUserService} from "../../services/pinhole.user.service";

@Component({
    selector: 'add-server-property',
    templateUrl: './add-server-property.component.html',
    imports: [
        ReactiveFormsModule,
        AlertComponent
    ],
    providers: [AlertService]
})
export class AddServerPropertyComponent implements OnDestroy {
    private subscriptions: Subscription[] = [];
    private formBuilder = new FormBuilder().nonNullable
    private name = this.formBuilder.control("")
    private value = this.formBuilder.control("")

    readonly iid = input.required<string>();
    isLoading: boolean = false;

    form = new FormGroup({
        name: this.name,
        value: this.value
    });

    constructor(private service: PinholeUserService, private alertService: AlertService) {

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    add() {
        this.alertService.clearAlerts();
        this.isLoading = true;
        this.subscriptions.push(
            this.service.addProperty({
                iid: this.iid(),
                name: this.name.value,
                value: this.value.value
            }).subscribe({
                next: () => {
                    this.alertService.showAlert('success', "Success updating");
                    this.isLoading = false;
                },
                error: (_: HttpErrorResponse) => {
                    this.alertService.showAlert('danger', "Error updating");
                    this.isLoading = false;
                }
            }))
    }
}
